/**
 * Product analytics subscription: when enabled (amount > 0), individual product
 * analysis pages (/products/analysis/:slug) require products_subscription_active
 * on the user's Firestore document. The /products catalog remains public.
 */
export function getPublicProductsSubscriptionAmount() {
  const raw = process.env.REACT_APP_PUBLIC_PRODUCTS_SUBSCRIPTION_AMOUNT;
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    return 0;
  }
  const n = parseFloat(String(raw).replace(/,/g, ''));
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function isPublicProductsSubscriptionRequired() {
  return getPublicProductsSubscriptionAmount() > 0;
}

export function getPublicProductsSubscriptionCurrency() {
  return (process.env.REACT_APP_PUBLIC_PRODUCTS_SUBSCRIPTION_CURRENCY || 'JMD').trim() || 'JMD';
}
